<template>
  <div :ref="ename" class="ec"></div>
</template>
    
    <script>
import * as echarts from "echarts";
import { fontSize } from "@/js/utils";

var placeHolderStyle = {
  normal: {
    label: {
      show: false,
    },
    labelLine: {
      show: false,
    },
    color: "rgba(0,0,0,0)",
    borderWidth: 0,
  },
  emphasis: {
    color: "rgba(0,0,0,0)",
    borderWidth: 0,
  },
};

var dataStyle = {
  normal: {
    show: false,
  },
};
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ename: {
      type: String,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    onclick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myChart: "",
      list: [],
      ab: "123",
      option: {
        title: [
          {
            text: "在线设备",
            left: "29.5%",
            top: "65%",
            textAlign: "center",
            textStyle: {
              fontWeight: "normal",
              fontSize: fontSize(0.16),
              color: "#fff",
              textAlign: "center",
            },
          },
          {
            text: "离线设备",
            left: "70%",
            top: "65%",
            textAlign: "center",
            textStyle: {
              color: "#fff",
              fontWeight: "normal",
              fontSize:  fontSize(0.16),
              textAlign: "center",
            },
          },
          {
            text: "",
            left: "29.5%",
            top: "center",
            textAlign: "center",
            textStyle: {
              fontWeight: "normal",
              fontSize:  fontSize(0.18),
              color: "#fff",
              textAlign: "center",
            },
          },
          {
            text: "",
            left: "70%",
            top: "center",
            textAlign: "center",
            textStyle: {
              color: "#fff",
              fontWeight: "normal",
              fontSize:  fontSize(0.18),
              textAlign: "center",
            },
          },
        ],
        series: [
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["60%", "70%"],
            center: ["30%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                show: true,
                position: "center",
              },
            },
            data: [
              {
                value: 75,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "#99da69",
                      },
                      {
                        offset: 1,
                        color: "#01babc",
                      },
                    ]),
                  },
                },
                label: dataStyle,
              },
              {
                value: 25,
                itemStyle: placeHolderStyle,
              },
            ],
          },
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["60%", "70%"],
            center: ["70%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
                show: true,
              },
            },
            data: [
              {
                value: 20,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "#9f3edd",
                      },
                      {
                        offset: 1,
                        color: "#4897f6",
                      },
                    ]),
                  },
                },
                label: dataStyle,
              },
              {
                value: 80,
                itemStyle: placeHolderStyle,
              },
            ],
          },

          //外圈的边框
          {
            // name: '总人数',
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["70%", "71%"],
            center: ["30%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 75,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "#01babc",
                      },
                      {
                        offset: 1,
                        color: "#99da69",
                      },
                    ]),
                  },
                },
              },
              {
                value: 25,
                itemStyle: placeHolderStyle,
              },
            ],
          },
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["70%", "71%"],
            center: ["70%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 75,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "#4897f6",
                      },
                      {
                        offset: 1,
                        color: "#9f3edd",
                      },
                    ]),
                  },
                },
              },
              {
                value: 25,
                itemStyle: placeHolderStyle,
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    full() {
      return this.$store.state.menuShow;
    },
  },
  watch: {
    full(newval) {
      this.myChart.resize();
    },
    data: {
      handler(newVal) {
        if (newVal && this.myChart != "") {
          this.list = newVal;
          this.updateOption();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getEchartData();
    window.addEventListener("resize", this.myChart.resize);
  },
  beforeDestroy() {
    // 移除窗口改变监听
    this.onclick && this.myChart.off("click", this.getClickInfo);
    window.removeEventListener("resize", this.myChart.resize);
  },
  methods: {
    getClickInfo(e) {
      this.$emit("click", e);
    },
    updateOption() {
      this.handlerData();
      this.myChart.setOption(this.option);
    },
    handlerData() {
      this.option.title[2].text = this.data.on + "台";
      this.option.title[3].text = this.data.off + "台";

      let total = this.data.on + this.data.off;

      let onratio = (this.data.on / total) * 100;
      let offratio = (this.data.off / total) * 100;

      this.option.series[0].data[0].value = onratio < 75 ? onratio : 75;
      this.option.series[0].data[1].value = 25;

      this.option.series[1].data[0].value = offratio < 75 ? offratio : 75;
      this.option.series[1].data[1].value = 25;
    },
    getEchartData() {
      this.handlerData();
      const chart = this.$refs[this.ename];
      if (chart) {
        this.myChart = this.$echarts.init(chart);
        this.myChart.setOption(this.option);
        this.onclick && this.myChart.on("click", this.getClickInfo);
      }
    },
  },
};
</script>
    
    <style lang="less" scoped>
.ec {
  width: 100%;
  height: 100%;
}
</style>